export default __webpack_public_path__ + "static/1-1b424c593b9d45221cd3366a5126b3f4.svg";